import { Tutorial as TutorialName } from 'constants/tutorials';
import { RootGetters, Store } from 'stores/type';

export type Tutorial = {
  name: TutorialName,
  check: () => boolean,
  next?: TutorialName,
  hide: () => Promise<void>,
};

export const enum TextTutorialId {
  FINAL = 'final',
  EXHAUSTED = 'exhausted',
  BASE = 'base',
  HINTS = 'hints',
  DLC = 'dlc',
  ENCYCLOPEDIA_INTRO = 'encyclopediaIntro',
  GAME_END = 'gameEnd',
  GAME_COMPLETION = 'gameCompletion',
}

export type TextTutorialPositionVertical = 0 | 1 | 2;
export type TextTutorialPositionHorizontal = 0 | 1 | 2;
export type TextTutorialPosition = {
  vertical: TextTutorialPositionVertical,
  horizontal: TextTutorialPositionHorizontal,
};

export type TextTutorial = {
  id: TextTutorialId,
  text: string | ((getters: RootGetters) => string),
  watcher: (getters: RootGetters) => boolean,
  after?: (getters: RootGetters) => Promise<void>,
  delay?: number,
  getPosition: ($store: Store) => TextTutorialPosition,
};

